angular.module('website').controller('website.waiverReceiptCtrl', ["$scope", "$stateParams", "DataService", "Restangular", "receipt", function($scope, $stateParams, DataService, Restangular, receipt) {
  var waiver;
  $scope.waiver = receipt;
  waiver = Restangular.one('websites', $stateParams.domain).one('waivers', $stateParams.waiverName).one('signed_waivers', $stateParams.signedWaiverId);
  $scope.currency = DataService.currency;
  $scope.params = {};
  $scope.resendEmail = function() {
    $scope.params.error = void 0;
    $scope.params.resendSuccessful = false;
    $scope.params.resendLoading = true;
    return waiver.doPUT({}, 'resend_receipt_email').then(function() {
      $scope.params.resendSuccessful = true;
      return $scope.params.resendLoading = false;
    });
  };
  return $scope.submitPassword = function() {
    var params;
    if (!$scope.params.passcode || $scope.params.submitLoading) {
      return;
    }
    $scope.params.error = void 0;
    $scope.params.resendSuccessful = false;
    $scope.params.submitLoading = true;
    params = {
      withoutNamespace: true,
      waiver_password: $scope.params.passcode
    };
    return waiver.doPUT(params, "authenticate_receipt").then(function() {
      return waiver.doGET('receipt').then(function(receipt) {
        $scope.params.submitLoading = false;
        return $scope.waiver = receipt;
      });
    }, function(response) {
      $scope.params.submitLoading = false;
      if (response.data.error === 'password_incorrect') {
        $scope.params.error = 'Incorrect passcode provided.';
      }
      if (response.data.error === 'link_expired') {
        return $scope.params.error = 'Password expired. Click "Re-send Waiver email" to generate a new one.';
      }
    });
  };
}]);
